import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs";
import "prismjs/components/prism-json";
import "prismjs/themes/prism-solarizedlight.min.css";
import "./JsonEditor.css";

type JsonEditorProps = {
  value: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  height?: string;
};

const JsonEditor = ({ value, onChange, disabled = false, height = "600px" }: JsonEditorProps) => {
  return (
    <div
      className="json-editor-wrapper"
      style={{
        borderRadius: "8px",
        overflow: "auto",
        height,
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
        backgroundColor: "#000",
        border: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <Editor
        value={value}
        onValueChange={(code) => !disabled && onChange?.(code)}
        highlight={(code) => highlight(code || "", languages.json, "json")}
        padding={16}
        disabled={disabled}
        style={{
          fontFamily: "'Fira Code', 'Cascadia Code', 'Consolas', monospace",
          fontSize: 13,
          lineHeight: 1.6,
          minHeight: height,
          outline: "none",
          color: "#eee",
          caretColor: "#fff",
          whiteSpace: "pre",
        }}
      />
    </div>
  );
};

export default JsonEditor;
